<template>
	<div class="w-32 flex items-center">
		<span v-if="editable" class="w-4 h-4 rounded-full mr-1" :style="{ backgroundColor: getActiveStatus }" />
		<app-select
			v-if="editable"
			class="status-select flex-1"
			:class="$attrs.class"
			label="label"
			track-by="value"
			:max-height="600"
			:modelValue="order.status"
			:options="orderStatuses"
			:loading="loading"
			:disabled="disabled"
			:canDeselect="false"
			@select="(status) => statusChangeHandler(status, false)"
		/>
		<p class="text-white px-3 py-2" v-else :style="{ backgroundColor: getActiveStatus, borderRadius: '2px' }">
			{{ getStatus }}
		</p>
	</div>
</template>

<script>
	import mapOrderStatuses from '@/constants/mapOrderStatuses';
	import OrderService from '@/services/OrderService';
	import AppSelect from '@/components/app/AppSelect';
	import * as yup from 'yup';

	export default {
		name: 'OrderStatusChange',
		components: { AppSelect },
		props: ['order', 'loading', 'disabled', 'editable'],
		data: () => ({
			orderStatuses: mapOrderStatuses,
			rejectReasonModal: false,
			rejectionType: null,
			rejectReason: {
				id: null,
				notes: '',
			},
			rejectionTypes: [],
			rejectReasonsOptions: [],
			schema: {
				notes: {
					component: 'app-text-area',
					name: 'Notes',
					rows: '6',
					placeholder: 'Notes',
					validations: yup
						.string()
						.required()
						.label('Notes'),
				},
			},
			loadingTypes: false,
			renderSelect: true,
		}),
		computed: {
			getActiveStatus() {
				let orderStatus = this.orderStatuses.find((_status) => _status.value === this.order.status);
				return orderStatus && orderStatus.color;
			},
			getStatus() {
				let orderStatus = this.orderStatuses.find((_status) => _status.value === this.order.status);
				return orderStatus && orderStatus.label;
			},
		},
		methods: {
			statusChangeHandler(selectedOption, reasonable) {
				let _payload = { status: selectedOption };
				if (selectedOption === 'REJECTED' && !reasonable) {
					this.getRejectReasonTypes();
					this.getRejectReason();
					this.rejectReasonModal = true;
				} else if (selectedOption === 'REJECTED' && reasonable) {
					_payload.reason = {
						rejectReason: { id: this.rejectReason.id },
					};
					if (this.rejectReason.id === 0 && this.rejectReason.notes) {
						_payload.reason.notes = this.rejectReason.notes;
					}
					this.$emit('onStatusChange', _payload);
					this.rejectReasonModal = false;
				} else {
					this.$emit('onStatusChange', _payload);
				}
			},
			getRejectReasonTypes() {
				this.loadingTypes = true;
				OrderService.getRejectReasonTypes()
					.then((res) => {
						this.reRenderFilters();
						this.rejectionTypes = res;
					})
					.catch((e) => {
						this.$notificationService.error(e);
					})
					.finally(() => (this.loadingTypes = false));
			},
			getRejectReason(type = this.rejectionType) {
				this.loadingTypes = true;
				OrderService.getRejectReason(type)
					.then((res) => {
						this.rejectReasonsOptions = res;
						this.rejectReason.id = res[0].id;
						this.reRenderFilters();
					})
					.catch((e) => {
						this.$notificationService.error(e);
					})
					.finally(() => (this.loadingTypes = false));
			},
			reRenderFilters() {
				this.renderSelect = false;
				this.$nextTick(() => {
					this.renderSelect = true;
				});
			},
		},
		watch: {
			rejectionType(newVal) {
				this.getRejectReason(newVal);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.status-select {
		@apply m-0 h-6;
		:deep(.multiselect-input) {
			@apply h-6 p-0 m-auto;
			.multiselect-single-label {
			}
		}

		:deep(.multiselect-spinner) {
			top: -5px;
			right: 7px;
		}

		&.small {
			@apply h-4;
			:deep(.multiselect-placeholder),
			:deep(.multiselect-single-label),
			:deep(.multiselect-multiple-label) {
				@apply text-13 pl-1 leading-none;
			}

			:deep(.multiselect-input) {
				@apply h-4;
			}
		}
	}
</style>
